import { State as PurchaseStoreState } from '~/store/reducers/purchase/models';
import { maskPhoneNumber } from '@sunbit-dev/purchase-common/src/helpers/logs';
import { PurchaseLogs } from './models';

export const getPurchaseLogsInfo = (purchaseInfo: PurchaseStoreState['purchaseInfo']): PurchaseLogs => {
  const {
    customerPhoneNumber,
    merchantVertical,
    merchantType,
    origin,
    onlinePurchaseSupportedTypes,
    merchantOriginatorActiveStates,
    merchantOriginator,
    merchantId,
    chainFeatures,
    amountRequested,
    applicationAmountFinancedLowerLimit,
    applicationAmountLowerLimit,
    applicationAmountUpperLimit,
    merchantAprLowerLimit,
    merchantAprUpperLimit,
    status,
    loanApplicationId,
    loanApplicationOrigin,
    loanApplicationType,
    allianceGeneralInfo,
  } = purchaseInfo || {};

  return {
    customerPhoneNumber: maskPhoneNumber(customerPhoneNumber),
    merchantVertical,
    merchantType,
    origin,
    onlinePurchaseSupportedTypes,
    merchantActiveStates: (merchantOriginatorActiveStates || []).join(', '),
    merchantOriginator,
    merchantId,
    chainFeatures,
    amountRequested,
    applicationAmountFinancedLowerLimit,
    applicationAmountLowerLimit,
    applicationAmountUpperLimit,
    merchantAprLowerLimit,
    merchantAprUpperLimit,
    status,
    loanApplicationId,
    loanApplicationOrigin,
    loanApplicationType,
    allianceGeneralInfo,
  };
};
